module.exports = __webpack_public_path__ + "static/media/RP-B_S_Jacquard_Palestro_DK Grey_Bordeaux.dea1ed58.png";